<template>
  <el-container id="main-container" class="main">
    <el-header class="main-head" style="height:8.12%;">
      <banner-header></banner-header>
      <el-container>
        <el-main style="min-width: 880px">
          <div
            class="main"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
          >
            <ClassTabs :list="clArticleList.top"></ClassTabs>
          </div>
        </el-main>
        <el-aside style="margin-left: 16px;">
          <expert-forum></expert-forum>
          <right-space-adv :Space="advSpace"></right-space-adv>
        </el-aside>
      </el-container>
    </el-header>
    <el-main class="middle-adv">
      <div
        class="railing-adv"
        v-if="advList.Railing && advList.Railing.length > 0"
      >
        <a :href="advList.Railing[0].redirect" target="_blank">
          <img :src="advList.Railing[0].img" alt />
        </a>
      </div>
      <div
        class="center-adv"
        v-if="advList.Center && advList.Center.length > 0"
      >
        <div
          class="single-center"
          v-for="(item, index) in advList.Center"
          :key="index"
        >
          <a :href="item.redirect" target="_blank">
            <img :src="item.img" alt />
          </a>
        </div>
      </div>
    </el-main>
    <el-footer>
      <el-container>
        <el-main>
          <div
            class="main"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
          >
            <div class="side-class video-container" v-if="videoResult.center">
              <div class="video-tag">
                <div class="side-class-title">
                  <div class="title">
                    <div class="side-class-btn">
                      {{ videoResult.center.name }}
                    </div>
                    <div
                      class="more"
                      @click="toVideoList(videoResult.center.id)"
                    >
                      查看更多
                    </div>
                  </div>
                </div>
              </div>
              <VideoSwiper
                :videoList="videoResult.center.article"
              ></VideoSwiper>
            </div>

            <ClassTabs
              :list="clArticleList.bottom"
              :position="'bottom'"
            ></ClassTabs>
          </div>
        </el-main>
        <el-aside style="margin-left: 16px;">
          <!-- 会员单位 -->
          <member-unit></member-unit>
          <AdvBanner :banner="advList.Pack"></AdvBanner>
          <right-space-adv :Space="advList.FrontDown"></right-space-adv>
        </el-aside>
      </el-container>
    </el-footer>
  </el-container>
</template>

<script>
import BannerHeader from '../components/front/BannerHeader.vue'
import RightSpaceAdv from '../components/common/RightSpaceAdv.vue'
import AdvBanner from '../components/common/AdvBanner.vue'
import MemberUnit from '../components/front/MemberUnit.vue'
import ExpertForum from '../components/front/ExpertForum.vue'
import ClassTabs from '../components/front/ClassTabs.vue'
import VideoSwiper from '../components/front/VideoSwiper.vue'
const HEIGHT =
  document.body.clientHeight || document.documentElement.clientHeight
const WIDTH = document.body.clientWidth || document.documentElement.clientWidth
export default {
  components: {
    BannerHeader,
    MemberUnit,
    ExpertForum,
    RightSpaceAdv,
    AdvBanner,
    ClassTabs,
    VideoSwiper
  },
  data() {
    return {
      advList: {},
      advSpace: [], // 专家推荐下方广告
      up: true,
      style: { width: WIDTH + 'px', height: HEIGHT + 'px' },
      loading: false,
      bannerList: [],
      clArticleList: {},
      videoResult: {},
      loadingCount: 0
    }
  },
  computed: {
    getKeepAliveList() {
      return this.$store.state.keepAliveList
    },
    upShow() {
      return this.up
    }
  },
  created() {
    this.loading = true
    this.getAdvList()
    this.getClassAndArticle()
    this.getClassVideo()
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    toClickLogin() {
      console.log('toClickLogin')
      this.$refs.login.toLog()
    },
    handleScroll() {
      let top =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop
      if (top > 100) {
        this.up = true
      } else {
        this.up = false
      }
      // console.log('top', top, this.up);
    },
    top() {
      window.scrollTo(0, 0)
    },
    getAdvList() {
      this.httpGet(this.$root.getAdvList, {})
        .then((result) => {
          this.advList = { ...result }
          this.advSpace = result.Space
          let userInfo = this.$store.state.login.userInfo
          this.advSpace.unshift({
            id: '000',
            redirect:
              'http://sms.gxtong.net:7001/sms/sszxlogin?yhid=' +
              userInfo.username,
            img: require('@/assets/img/cfb-send.png')
          })
          this.loadingCount += 1
        })
        .catch((err) => {
          console.error('getAdvList-err', err)
        })
    },
    getClassAndArticle() {
      this.httpGet(this.$root.getClassAndArticle, {})
        .then((result) => {
          this.clArticleList = { ...result.list }
          this.loadingCount += 1
        })
        .catch((err) => {
          console.error('getClassAndArticle-err', err)
        })
    },
    getClassVideo() {
      this.httpGet(this.$root.getClassVideo, {})
        .then((result) => {
          this.videoResult = { ...result.list }
          this.loadingCount += 1
        })
        .catch((err) => {
          console.error('getClassVideo-err', err)
        })
    },
    toVideoList(id) {
      // 面包屑
      let breadObj = {
        id: id,
        path: 'video-list?id=' + id,
        name: this.videoResult.center.name
      }
      this.$store.commit('setBreadArr', breadObj)
      this.$router.push({
        name: 'video-list',
        query: {
          id: id
        }
      })
    }
  },
  watch: {
    up(newValue, oldValue) {
      console.log('uposhow---', newValue, oldValue)
    },
    loadingCount(newValue, oldValue) {
      if (newValue >= 2) {
        this.loading = false
      }
    },
    '$route.name': function(newValue, oldValue) {
      if (newValue === 'Welcome') {
        this.loading = true
        this.getAdvList()
        this.getClassAndArticle()
        this.getClassVideo()
      }
    },
    advSpace(newValue, oldValue) {}
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.head {
    flex-y(flex-start);
    position: relative;
}

.main-head {
    position: relative;
    top: 0;
    width: 100%;
}

.video-container {
    width: 100%;
    background: #F6F6F6;

    .side-class-title {
        padding-left: 0;
    }

    .title {
        width: 100%;
        flex-x(space-between);
    }
}

.container-right {
    flex-y(flex-start);
}

.el-header {
    padding: 0;
}

.el-aside {
    width: 280px !important;
}

.login-container {
    margin-top: 15px;
}

.cfbb-btn {
    width: 100%;
    height: 90px;
    // background: linear-gradient(180deg, #EA053B 0%, #4093FF 100%);
    margin-top: 15px;
    color: white;
    text-align: right;
    line-height: 90px;
    font-size: 28px;
    background: url('https://cfb-bucket.oss-cn-beijing.aliyuncs.com/static/cfbb.png') no-repeat;

    span {
        padding-right: 16px;
    }
}

.el-main {
    padding: 0;
    flex-direction: column;
    // margin: 0 16px;
    // margin-left: 16px;
    // // max-width: 734px;
    // border: 1px solid blue;
}

>>>.el-footer {
    height: auto !important;
    padding: 0;
    margin-top: 12px;
}

.more {
    more();
}

.more:hover {
    cursor: pointer;
    color: blue;
}

.middle-adv {
    width: 100%;
    min-width: 1180px;
    height: auto;
    margin-top: 20px;
    overflow: hidden;

    .railing-adv {
        height: 128px;

        img {
            width: 100%;
            max-width: 1180px;
            height: 100%;
            border-radius: 8px;
        }
    }

    .center-adv {
        width: 100%;
        height: 160px;
        margin-top: 10px;
        flex-x(space-between);

        .single-center {
            width: 24%;
            height: 100%;

            img {
                width: 100%;
                max-width: 280px;
                height: 100%;
                border-radius: 8px;
            }
        }
    }
}
</style>
